import { AccessToken } from '../utils/accessToken';

declare function unescape(s: string): string;
declare function escape(s: string): string;
 
export class Cookie {
    get CartGuid(): string {
        return this.getValue('TSC_CartGuid');
    }

    set CartGuid(value: string) {
        this.setValueSameSite('TSC_CartGuid', value, 21);
    }

    get OrderedCartGuid(): string {
        return this.getValue('TSC_OrderedCart.CartGuid');
    }

    set OrderedCartGuid(value: string) {
        this.setValue('TSC_OrderedCart.CartGuid', value, 1);
    }
    get TscClientIP(): string {
        return this.getValue('TSC_ClientIP');
    }

    get TimeZone(): string {
        return this.getValue('TSC_TimeZone');
    }

    set TimeZone(value: string) {
        this.setValue('TSC_TimeZone', value, 365);
    }

    get Language(): string {
        let language = this.getValue('TSC_Language');
        if (language) return language;
        else return 'en_CA';
    }

    set SignOutMessage(value: string) {
        let date = new Date();
        date.setTime(date.getTime() + 20000);
        this.setValueWithDate('TSC_SignOutMessage', value, date);
    }

    get SignOutMessage(): string {
        let SignOutMessage = this.getValue('TSC_SignOutMessage');
        this.setValue('TSC_SignOutMessage', '', -1);
        return SignOutMessage;
    }

    get UserName(): string {
        return this.getValue('TSC_UserName');
    }

    set UserName(value: string) {
        this.setValue('TSC_UserName', value, 21);
    }
    get LastName(): string {
        return this.getValue('TSC_LastName');
    }
    set LastName(value: string) {
        this.setValue('TSC_LastName', value, 21);
    }
    get CartProvince(): string {
        return this.getValue('TSC_Cart_Province');
    }

    set CartProvince(value: string) {
        this.setValue('TSC_Cart_Province', value, 21);
    }

    set Language(value: string) {
        this.setValue('TSC_Language', value, 365);
    }

    get StayInRegularSite(): string {
        return this.getValue('TSC_WEBFACTORY.StayInRegularSite');
    }

    set StayInRegularSite(value: string) {
        this.setValue('TSC_WEBFACTORY.StayInRegularSite', value, 21);
    }

    get TSCRWD(): string {
        return this.getValue('TSC_RWD');
    }

    set TSCRWD(value: string) {
        this.setValue('TSC_RWD', value, 21);
    }

    get ApiLanguage(): string {
        return this.Language.split('_')[0]; //For api calling, please refer to webapi.Service.post/get/put/delete
    }

    get UserEmail(): string {
        return this.getValue('TSC_UserEmail');
    }

    set UserEmail(value: string) {
        this.setValue('TSC_UserEmail', value.trim(), 90);
    }

    get PaypalPaymentId(): string {
        return this.getValue('TSC_PaypalPaymentId');
    }
    set PaypalPaymentId(value: string) {
        this.setValue('TSC_PaypalPaymentId', value.trim(), 1);
    }

    get PaypalPayerId(): string {
        return this.getValue('TSC_PaypalPayerId');
    }
    set PaypalPayerId(value: string) {
        this.setValue('TSC_PaypalPayerId', value.trim(), 1);
    }

    get PaypalTransactionId(): string {
        return this.getValue('TSC_PaypalTransactionId');
    }
    set PaypalTransactionId(value: string) {
        this.setValue('TSC_PaypalTransactionId', value.trim(), 1);
    }

    get PaypalPayerEmail(): string {
        return this.getValue('TSC_PaypalPayerEmail');
    }
    set PaypalPayerEmail(value: string) {
        this.setValue('TSC_PaypalPayerEmail', value.trim(), 1);
    }

    get UserAccessToken(): AccessToken {
        var cookieValue: string = this.getValue('TSC_UserToken');

        if (cookieValue == undefined) {
            return undefined;
        }

        var token: AccessToken = undefined;
        try {
            token = JSON.parse(cookieValue);
            if (token.Token == undefined || token.Token.length == 0 || token.Edp == undefined || token.Edp <= 0) {
                token = undefined;
            }
        } catch (ex) {
            token = undefined;
        }
        return token;
    }
    set UserAccessToken(value: AccessToken) {
        this.setValueSameSite('TSC_UserToken', JSON.stringify(value), 21);
    }

    set UserAccessTokenForSession(value: AccessToken) {
        this.setSessionValue('TSC_UserToken', JSON.stringify(value));
    }

    get AppToken(): string {
        var atoken: string = this.getValue('TSC_AppToken');
        //actual AppToken length varies, but this is the minimum
        if (atoken != undefined && atoken.trim().length < 128) {
            return undefined;
        }
        return atoken;
    }
    set AppToken(value: string) {
        this.setValue('TSC_AppToken', value, 21);
    }

    get PaypalAccessToken(): string {
        var atoken: string = this.getValue('TSC_PaypalAccessToken');
        return atoken;
    }
    set PaypalAccessToken(value: string) {
        let date = new Date();
        date.setSeconds(date.getSeconds() + 32000);
        this.setValueWithDate('TSC_PaypalAccessToken', value, date);
    }

    get TargetUrl(): string {
        return this.getValue('TSC_TargetUrl');
    }
    set TargetUrl(value: string) {
        this.setValue('TSC_TargetUrl', value, 1);
    }
    public deleteTargetUrl(): void {
        this.clearCookie('TSC_TargetUrl');
    }

    get ExpressCheckoutCreateAccount(): string {
        return this.getValue('TSC_ExpressCheckoutCreateAccount');
    }
    set ExpressCheckoutCreateAccount(value: string) {
        this.setValue('TSC_ExpressCheckoutCreateAccount', value, 1);
    }
    public deleteExpressCheckoutCreateAccount(): void {
        this.clearCookie('TSC_ExpressCheckoutCreateAccount');
    }
    //also set from server
    get RedirectToCart(): string {
        return this.getValue('TSC_RedirectToCart');
    }
    set RedirectToCart(value: string) {
        let date = new Date();
        date.setHours(date.getHours() + 1); //expires in an hour
        this.setValueWithDate('TSC_RedirectToCart', value, date);
    }
    public deleteRedirectToCart(): void {
        this.clearCookie('TSC_RedirectToCart');
    }

    //currently used for checkout redirected from create account
    get ReferrerUrl(): string {
        return this.getValue('TSC_ReferrerUrl');
    }
    set ReferrerUrl(value: string) {
        this.setValue('TSC_ReferrerUrl', value, 1);
    }
    public deleteReferrerUrl(): void {
        this.clearCookie('TSC_ReferrerUrl');
    }

    get GuestAccountLogin(): string {
        return this.getValue('TSC_GuestAccountLogin');
    }
    set GuestAccountLogin(value: string) {
        this.setValue('TSC_GuestAccountLogin', value, 1);
    }
    public deleteGuestAccountLogin(): void {
        this.clearCookie('TSC_GuestAccountLogin');
    }

    get ModifyOrderNumber(): string {
        return this.getValue('TSC_Modify_OrderNumber');
    }
    set ModifyOrderNumber(value: string) {
        let date = new Date();
        date.setHours(date.getHours() + 1); //expires in an hour
        this.setValueWithDate('TSC_Modify_OrderNumber', value, date);
    }

    get ModifyOrderPromocode(): string {
        return this.getValue('TSC_Modify_Promocode');
    }
    set ModifyOrderPromocode(value: string) {
        let date = new Date();
        date.setHours(date.getHours() + 1); //expires in an hour
        this.setValueWithDate('TSC_Modify_Promocode', value, date);
    }

    get HolidayPopup(): string {
        return this.getValue('TSC_Holiday_Popup');
    }
    set HolidayPopup(value: string) {
        let date = new Date();
        date.setHours(date.getHours() + 168); //168Hours = 7 days
        this.setValueWithDate('TSC_Holiday_Popup', value, date);
    }

    get RecentlyViewedItemNos(): string {
        return this.getValue('TSC_RecentlyViewed');
    }
    set RecentlyViewedItemNos(value: string) {
        this.setValue('TSC_RecentlyViewed', value, 21);
    }
    public deleteRecentlyViewedItemNos(): void {
        this.clearCookie('TSC_RecentlyViewed');
    }

    get CartMerge(): string {
        return this.getValue('TSC_IsCartMerge');
    }
    set CartMerge(value: string) {
        this.setValue('TSC_IsCartMerge', value, 1);
    }

    public deleteCartMerge(): void {
        this.clearCookie('TSC_IsCartMerge');
    }

    get CurrentDate(): string {
        var currentDate = this.getValue('TSC_CurrentDate');
        if (currentDate == undefined) {
            var date = new Date();
            return date.toJSON();
        }
        return this.getValue('TSC_CurrentDate');
    }
    set CurrentDate(value: string) {
        this.setValueWithHours('TSC_CurrentDate', value, 8);
    }

    get CartProductCount(): string {
        return this.getValue('TSC_CartProductCount');
    }
    set CartProductCount(value: string) {
        this.setValue('TSC_CartProductCount', value, 21);
        $('.bagCounter').text(value);
    }

    set ShipmethodAccessPointId(value: string) {
        this.setValue('TSC_UpsAccessPointId', value, 21);
    }

    get ShipmethodAccessPointId(): string {
        return this.getValue('TSC_UpsAccessPointId');
    }

    public deleteAccessPointId(): void {
        this.clearCookie('TSC_UpsAccessPointId');
    }

    public deleteCartGuid(): void {
        this.clearCookie('TSC_CartGuid');
    }
    public deleteOrderedCartGuid(): void {
        this.clearCookie('TSC_OrderedCart.CartGuid');
    }
    public deleteUserToken(): void {
        this.clearCookie('TSC_UserToken');
    }
    public deleteUserEmail(): void {
        this.clearCookie('TSC_UserEmail');
    }
    public deleteUserName(): void {
        this.clearCookie('TSC_UserName');
    }
    public deleteLastName(): void {
        this.clearCookie('TSC_LastName');
    }
    public deleteCartProductCount(): void {
        this.clearCookie('TSC_CartProductCount');
    }
    public deletePaypalInfo(): void {
        this.clearCookie('TSC_PaypalAccessToken');
        this.clearCookie('TSC_PaypalPaymentId');
        this.clearCookie('TSC_PaypalPayerId');
        this.clearCookie('TSC_PaypalTransactionId');
        this.clearCookie('TSC_PaypalPayerEmail');
    }
    public deleteModifyOrderInfo(): void {
        this.clearCookie('TSC_Modify_OrderNumber');
        this.clearCookie('TSC_Modify_Promocode');
    }
    public deleteModifyOrder_Promocode(): void {
        this.clearCookie('TSC_Modify_Promocode');
    }

    //public isAuthenticated(): boolean {
    //    return (this.UserAccessToken != undefined && this.UserAccessToken.Token.length > 0 && this.UserAccessToken.Edp > 0)
    //}

    private clearCookie(cookieName: string): void {
        this.setValue(cookieName, '', -1);
    }

    //common private functions
    getValue(name: string) {
        var i: number, x: string, y: string;
        var cookies: string[] = document.cookie.split(';');
        for (i = 0; i < cookies.length; i++) {
            x = cookies[i].substr(0, cookies[i].indexOf('='));
            y = cookies[i].substr(cookies[i].indexOf('=') + 1);

            x = x.replace(/^\s+|\s+$/g, '');
            if (x == name) {
                return unescape(y);
            }
        }
    }

    setValue(name: string, value: string, exdays: number) {
        var exdate = new Date();
        exdate.setDate(exdate.getDate() + exdays);
        this.setValueWithDate(name, value, exdate);
    }
    setValueSameSite(name: string, value: string, exdays: number) {
        var exdate = new Date();
        exdate.setDate(exdate.getDate() + exdays);
        this.setValueWithDateSameSite(name, value, exdate);
    }

    setValueWithDate(name: string, value: string, date: Date) {
        var c_value = escape(value) + ';secure; expires=' + date.toUTCString() + '; path=/';
        document.cookie = name + '=' + c_value;
    }
    setValueWithDateSameSite(name: string, value: string, date: Date) {
        var c_value = escape(value) + ';secure; expires=' + date.toUTCString() + '; path=/;' + ' sameSite=strict';
        document.cookie = name + '=' + c_value;
    }

    setValueWithHours(name: string, value: string, hours: number) {
        if (hours) {
            var date = new Date();
            date.setTime(date.getTime() + hours * 60 * 60 * 1000);
            var expires = '; expires=' + date.toUTCString();
        } else {
            var expires = '';
        }
        document.cookie = name + '=' + value + expires + '; path=/';
    }

    //session cookie that also supports IE
    setSessionValue(name: string, value: string) {
        document.cookie = name + '=' + escape(value) + ';  path =/';
    }

    get AutoPlayVideos(): string {
        return this.getValue('TSC_AutoPlayVideos');
    }

    set AutoPlayVideos(value: string) {
        this.setValue('TSC_AutoPlayVideos', value, 21);
    }

    get VideoSound(): string {
        return this.getValue('TSC_VideoSound');
    }

    set VideoSound(value: string) {
        this.setValue('TSC_VideoSound', value, 21);
    }
}



// WEBPACK FOOTER //
// C:/AzureDevOpsAgent/_work/3/s/TSC.Web.WebFactory/node_modules/ngc-webpack??ref--0-1!C:/AzureDevOpsAgent/_work/3/s/TSC.Web.WebFactory/node_modules/angular2-template-loader!../utils/cookie.ts